import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { unboxLabel } from '../Configurations';
import { optionFilterBySystem } from '../inputs/ConfigurationSelect';
import { ConfigurationSelect } from '../inputs/ConfigurationSelect';
import { ConfigurationComponent } from '.';

const WoodTypeConfig = () => (
  <ConfigurationSelect
    configurationKey="woodType"
    dispatchAction="SET_WOOD_TYPE"
    optionsFilterFn={optionFilterBySystem}
  />
);

const config: ConfigurationComponent<'woodType'> = {
  key: 'woodType',
  input: <WoodTypeConfig />,
  display: (value: ConfigurationValues['woodType']) => (
    <span>{unboxLabel(value.label)}</span>
  ),
};

export default config;
